<template>
  <div class="columns m-0 p-0 tag-style" :style="[hidden ? {'opacity': 0} : 'opacity:1']">
    <b-tooltip :label="tooltipText()" :delay="1000" type="is-dark" class="column is-8 m-0 p-0">
      <div class="tag-start has-text-centered" :style="statusStyle()">{{ name }}</div>
    </b-tooltip>
    <div class="column is-4 m-0 p-0 tag-end has-text-centered" style="background: #dedede">{{ statusText() }}</div>
  </div>
</template>

<script>
export default {
  name: "live-tag",
  props: {
    name: {
      type: String
    },
    hidden: {
      type: Boolean,
      default: false
    },
    tasks: {
      type: Object
    },
    propertySet:{
      type: Boolean
    }
  },
  methods: {
    statusStyle() {
      if (this.tasks) {
        if (this.tasks.status === 'CREATED') {
          return {background: '#8C84FF'}
        } else if (this.tasks.status === 'RUNNING') {
          return {background: '#D8BA13'}
        } else if (this.tasks.status === 'COMPLETED') {
          return {background: '#1CAB80'}
        } else if (this.tasks.status === 'FAILED') {
          return {background: '#e02c2c'}
        }
      }
      return this.propertySet === true ? {background: '#b4b4b4'} : {background: '#dadada'}
    },
    statusText() {
      if (this.tasks) {
        if (this.tasks.status === 'CREATED') {
          return `${this.tasks.created}/${this.tasks.numOfTasks}`
        } else if (this.tasks.status === 'RUNNING') {
          return `${this.tasks.queued + this.tasks.inProgress}/${this.tasks.numOfTasks}`
        } else if (this.tasks.status === 'COMPLETED') {
          return `${this.tasks.completed}/${this.tasks.numOfTasks}`
        } else if (this.tasks.status === 'FAILED') {
          return `${this.tasks.failed}/${this.tasks.numOfTasks}`
        }
      }


      return this.propertySet === true ? `Waiting...` : `N/A`
    },
    tooltipText(){
      if (this.tasks) {
        if (this.tasks.status === 'CREATED') {
          return `Created ${this.tasks.created}/${this.tasks.numOfTasks}`
        } else if (this.tasks.status === 'RUNNING') {
          return `Running ${this.tasks.queued + this.tasks.inProgress}/${this.tasks.numOfTasks}`
        } else if (this.tasks.status === 'COMPLETED') {
          return `Completed ${this.tasks.completed}/${this.tasks.numOfTasks}`
        } else if (this.tasks.status === 'FAILED') {
          return `Failed ${this.tasks.failed}/${this.tasks.numOfTasks}`
        }
      }
      return this.propertySet === true ? `Waiting processing...` : `Unknown status`
    }
  }
}
</script>

<style scoped>
.tag-start {
  border-radius: 4px 0 0 4px;
  color: white;
  font-size: 10px;
  font-weight: normal;
}

.tag-end {
  border-radius: 0 4px 4px 0;
  color: #383838;
  font-size: 10px;
}
</style>